import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop · Wave Final fix routing (Feb 2026)
 *
 * Reset dello scroll al top della pagina ad ogni cambio rotta.
 * Risolve il bug "/frazione/battaglia carica dal fondo" che si presentava
 * quando si cliccava un link interno con la pagina precedente scrollata.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    // `behavior: instant` evita l'animazione fastidiosa al primo paint
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}
